module.exports = __webpack_public_path__ + "img/icon-t1.3455142f.png";